import { Link, useParams } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { ObservationPanel } from '@/components/ObservationPanel';
import { ResetPanel } from '@/components/ResetPanel';
import { trpc } from '@/trpc/client';

/**
 * LINE-user detail page. Loads state + history + send/event logs via
 * `trpc.lineUser.get` and renders them in the collapsible
 * {@link ObservationPanel}. Admin role additionally sees the
 * {@link ResetPanel} for destructive reset operations.
 */
export function LineUserDetail(): JSX.Element {
  const { userId = '' } = useParams<{ userId: string }>();
  const { user } = useAuth();
  const query = trpc.lineUser.get.useQuery({ userId }, { enabled: userId.length > 0 });

  return (
    <div className="space-y-4">
      <div>
        <Link to="/line-users" className="text-sm text-gray-600 hover:underline">
          ← ユーザー一覧へ戻る
        </Link>
        <h1 className="mt-1 font-mono text-xl font-bold">{userId}</h1>
      </div>
      {query.isLoading ? (
        <p className="text-sm text-gray-500">読み込み中…</p>
      ) : query.error ? (
        <p className="text-sm text-red-600">エラー: {query.error.message}</p>
      ) : (
        <ObservationPanel
          userId={userId}
          state={query.data?.state ?? null}
          history={query.data?.history ?? []}
          sendLog={query.data?.sendLog ?? []}
          eventLog={query.data?.eventLog ?? []}
        />
      )}
      {user?.role === 'admin' ? <ResetPanel userId={userId} /> : null}
    </div>
  );
}
